import { useSelector } from "react-redux"
import { selectCurrentUser } from "Shared/session"

/** Façade sur `selectCurrentUser`. Remplace la prop injectée `currentUser` du Layout. */
export const useCurrentUser = () => useSelector(selectCurrentUser)
